export default "__VITE_ASSET__BPLDdswf__"